import { FC } from 'react'
import { useSelector } from 'react-redux'

import { getWagePremiumName } from 'services/Utilities'
import { t } from 'translations'

type Props = {
  wagePremiums: MData.PunchCard['wagePremiums']
}

const WagePremiums: FC<Props> = ({ wagePremiums = [] }) => {
  const { wagePremiumsById: wagePremiumTypesById } = useSelector((state: MStore.RootState) => state.resources)

  return (
    <>
      {wagePremiums.map(({ _id, hasHourMultipler, earningCode, hourMultiplier, hours = 0, unitBased, units = 0 }, index) => (
        <div key={index}>
          <b className="mr-1">
            {unitBased ? (
              <>
                {units} {wagePremiumTypesById[_id]?.unitaryAmountType || t('manager.schedule.eventForm.WAGEPREMIUMUNITS.UNITS')}
              </>
            ) : (
              <>
                {hasHourMultipler && hourMultiplier !== 1 ? `${hourMultiplier}x` : ''}
                {!hours ? '' : `${hours}h`}
              </>
            )}
          </b>
          {getWagePremiumName(_id)} <b>{earningCode}</b>
        </div>
      ))}
    </>
  )
}

export default WagePremiums
